// extracted by mini-css-extract-plugin
export default {"component":"s0vI1"};